module.exports = "/assets/images/ico-zasuvka-1w.fb4704d2.png";